import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import MasterGamesList from "../data/MasterGamesList"

export default function TPGRiseOfHellFire() {
  const navigate = useNavigate()
  const data = promotionsData.find(
    (promo) => promo.title === "TPG Rise of Hellfire"
  )

  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> TPG Rise of Hellfire </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> /
              <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> TPG Rise of Hellfire </h1>
                <h2> Total 5,552 Free Spins (1,388 Free Spins each week) </h2>
                <div className="promotion-tnc-period">
                  <strong> Promo Period: </strong>
                  <span>December 1 - December 28, 2025 (GMT + 8)</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong> Terms & Conditions </strong>
                <ol>
                  <li>
                    Campaign duration: December 1, 2025 – December 28, 2025
                    (GMT+8).
                  </li>
                  <ul>
                    <li>
                      Week 1: 1 December 00:00:00 – 7 December 23:59:59 (GMT+8)
                    </li>
                    <li>
                      Week 2: 8 December 00:00:00 – 14 December 23:59:59 (GMT+8)
                    </li>
                    <li>
                      Week 3: 15 December 00:00:00 – 21 December 23:59:59
                      (GMT+8)
                    </li>
                    <li>
                      Week 4: 22 December 00:00:00 – 28 December 23:59:59
                      (GMT+8)
                    </li>
                  </ul>
                  <li>
                    The following games participate in the campaign
                    (“Participating games”): Rise of Hellfire
                    <MasterGamesList
                      pragmaticGamesOnly="on"
                      customWrapperClass="gameListWrapper promotion-signup-game-list"
                      customPragmaticGames={[
                        {
                          provider: "tpg",
                          gameName: "Rise of Hellfire",
                        },
                      ]}
                      rank="off"
                      limit={2}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                  </li>

                  <li>
                    Only real money rounds can participate in the tournament.
                  </li>
                  <li>
                    Participating players can join the campaign by placing a
                    qualifying bet on the designated game during the campaign
                    period. No additional cost is required.
                  </li>

                  <li>
                    The top 10 players with the highest wagers each week in
                    “Rise of Hellfire” will be recognized as winners.
                  </li>
                  <li>
                    Each player’s total weekly accumulated gross bets will be
                    calculated and the leaderboard will be updated every week
                    between 12 PM and 2 PM (GMT+8).
                  </li>

                  <li>
                    Free Spins will be credited to the game accounts of the top
                    10 players (for a specific game) on the next business day
                    after each weekly campaign.
                  </li>

                  <li>
                    The awarded Free Spins can only be used on the specific TPG
                    slot game: Rise of Hellfire
                  </li>
                </ol>

                <div className="promotion-tnc-cta">
                  <a
                    href="https://tournament.triple-pg.com/tpg-rise-of-hellfire-ultimate-challenge/"
                    className="promotion-cta-btn"
                    target="_blank"
                  >
                    Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
